<template>
  <nav />
</template>
<script>
import { getSpaceByURL } from '../../api/spaceApi';
export default {
   
   async created(){
        var space = window.location.host.split('.')[0];
        if(space != 'id') {
            try {
                const response = await getSpaceByURL(space)
                if(response.status){
                    if(response.status == 200) {
                        await this.proceedSpaceData(response)
                        const currentUserRole = JSON.parse(localStorage.space).role
                        if (currentUserRole == 'participant' || currentUserRole == 'guest') {
                            this.$router.push(this.$route.query.redirect || 'dashboard-participant')
                        } else if (currentUserRole == 'booster' || currentUserRole == 'space_admin') {
                            this.$router.push(this.$route.query.redirect || '/dashboard')
                        } else {
                            this.$router.push({path: '/'})
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 403){
                        this.$router.push({path: '/forbidden'})
                    }
                    if(e.response.status == 404){
                        this.$router.push('/not-exist')
                    }
                }
            }
        } 
    },
    methods: {
        proceedSpaceData(response){
            localStorage.space = JSON.stringify(response.data.data.attributes)
            this.$store.dispatch("getSubscribedPlan", response.data.data).catch(error => {
                if (error.response.status == 403) {
                    this.$router.push({name: 'PageAccessDenied'})
                }
                if (error.response.status == 404) {
                    this.$router.push({name: 'PageNotFound'})
                }
            })
        }
    }
}
</script>